import { NodeWithSvg } from '../../../NodeWithSvg';
import { useLink } from '../../link.hook';
import { ILinkBtn } from './linkBtn.models';
import * as S from './linkBtn.style';

export const Btn: React.FC<ILinkBtn> = ({
  children,
  disabled,
  onClick: _onClick,
  onMouseEnter: _onMouseEnter,
  onMouseLeave: _onMouseLeave,
  size: _size,
  svg,
  svgPosition,
  type = 'button',
  variant = 'regular',
  ...rest
}) => {
  const { color, height, onClick, onMouseEnter, onMouseLeave, size } = useLink<HTMLButtonElement>({
    _onClick,
    _onMouseEnter,
    _onMouseLeave,
    _size,
    disabled,
    variant,
  });

  return (
    <S.Button
      {...rest}
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      size={size}
      type={type}
      variant={variant}
    >
      <NodeWithSvg color={color} height={height} svg={svg} svgPosition={svgPosition}>
        {children}
      </NodeWithSvg>
    </S.Button>
  );
};

